import { IUserCreateState } from 'store/UserCreate/UserCreate.type';

export function isStepOneFilled(
  stepOneData: IUserCreateState['stepOne'],
): boolean {
  const { fullname, email, password, phoneNumber } = stepOneData;
  return !!(fullname.trim() || email.trim() || password.trim() || phoneNumber.trim());
}

export function isStepTwoFilled(
  stepTwoData: IUserCreateState['stepTwo'],
): boolean {
  const { details } = stepTwoData;

  if (!details || details.length === 0) {
    return false;
  }

  for (const detail of details) {
    if (detail.name?.trim()) {
      return true;
    }

    if (detail.file) {
      return true;
    }

    if (detail.zones && detail.zones.length > 0) {
      for (const zone of detail.zones) {
        if (
          zone.name?.trim() ||
          zone.plantType ||
          zone.plantName ||
          zone.soilType ||
          zone.photo
        ) {
          return true;
        }

        if (zone.sensors && zone.sensors.length > 0) {
          for (const sensor of zone.sensors) {
            if (sensor.sensorEui?.trim() || sensor.type) {
              return true;
            }
          }
        }
      }
    }

    if (detail.sensors && detail.sensors.length > 0) {
      for (const sensor of detail.sensors) {
        if (sensor.sensorEui?.trim() || sensor.type) {
          return true;
        }
      }
    }
  }

  return false;
}

export function isUserCreateFormFilled(
  userCreateData: IUserCreateState,
): boolean {
  const isStepOneSaved = !!userCreateData.userId;
  return (
    (!isStepOneSaved && isStepOneFilled(userCreateData.stepOne)) ||
    isStepTwoFilled(userCreateData.stepTwo)
  );
}
